'use client';

import { useTranslations } from 'next-intl';
import { QRCodeSVG } from 'qrcode.react';
import { use } from 'react';
import { trpc } from '@/app/_trpc/client';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Skeleton } from '@/components/ui/skeleton';
import { DesktopPushNotificationDialogContext } from '../context/DesktopPushNotificationDialogContext';

export function DesktopPushNotificationDialog() {
  const t = useTranslations('DesktopPushNotificationDialog');
  const { shouldShowDesktopDialog, closeDesktopDialog } = use(
    DesktopPushNotificationDialogContext
  );
  const { data, isLoading } = trpc.auth.getMagicLoginLink.useQuery(undefined, {
    enabled: shouldShowDesktopDialog,
  });
  const magicLink = data?.url;

  if (!shouldShowDesktopDialog) return null;

  return (
    <Dialog open={shouldShowDesktopDialog} onOpenChange={closeDesktopDialog}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle data-testid='desktop-push-notification-dialog-title'>
            {t('title')}
          </DialogTitle>
          <DialogDescription>{t('description')}</DialogDescription>
        </DialogHeader>
        <div className='my-4 flex min-h-[180px] justify-center'>
          {isLoading ? (
            <Skeleton className='h-[180px] w-[180px]' />
          ) : magicLink ? (
            <QRCodeSVG value={magicLink} size={180} />
          ) : null}
        </div>
        <DialogFooter>
          <Button onClick={closeDesktopDialog}>{t('close')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
